import React from 'react';

export default function GroupHeaderRenderer(props) {
  const { displayName } = props;
  const dataTestId =
    props?.dataTestId || props?.params?.dataTestId || 'hdrGroup';
  return (
    <div
      className="ag-header-group-cell-label"
      data-testid={`grdCol${dataTestId}`}
    >
      <span className="ag-header-group-text">{displayName}</span>
    </div>
  );
}
